// src/pages/publish/components/EnvironmentColumn.tsx
import React from 'react';

interface EnvironmentColumnProps {
  title: string;
  type: 'internal' | 'published';
  children: React.ReactNode;
}

export const EnvironmentColumn: React.FC<EnvironmentColumnProps> = ({ title, type, children }) => {
  const isInternal = type === 'internal';
  
  // 样式变量
  const headerBg = isInternal ? 'bg-blue-50/50' : 'bg-green-50/50';
  const dotColor = isInternal ? 'bg-blue-500' : 'bg-green-500';
  const badgeBg = isInternal ? 'bg-blue-100' : 'bg-green-100';
  const badgeText = isInternal ? 'text-blue-700' : 'text-green-700';
  const badgeLabel = isInternal ? '待发布' : '线上版本';

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 flex flex-col overflow-hidden h-full">
      {/* Column Header */}
      <div className={`p-4 border-b border-gray-100 ${headerBg} flex justify-between items-center`}>
        <div className="flex items-center gap-2">
          <span className={`w-2 h-2 rounded-full ${dotColor}`}></span>
          <h2 className="font-semibold text-gray-800">{title}</h2>
        </div>
        <span className={`text-xs px-2 py-1 ${badgeBg} ${badgeText} rounded-full`}>
          {badgeLabel}
        </span>
      </div>
      
      {/* Scrollable Content Area */}
      <div className="flex-1 overflow-auto p-4 custom-scrollbar">
        {children}
      </div>
    </div>
  );
};
